import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {SettingsSection, SettingsSectionTitleDict} from "../../../app/settings/@const";

// const debug = "AttachmentsModule"
const debug = false

export class AttachmentsModule extends ModuleProto {

    constructor(moduleConfig: JSONObject) {
        super(ModuleType.ATTACHMENTS, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                     = "Attachments"
        this.description              = "The Attachments module provides a convenient way to upload and share files within your workspace. This feature allows users to attach files to tasks, projects, or comments, making it easy to collaborate and share important documents with team members. Whether it's images, documents, or other file types, the Attachments module ensures that all relevant files are easily accessible and organized, enhancing productivity and collaboration."
        this.svgIcon                  = "isvg-attachments"
        this.settingsMenuTopCategory  = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel                = SettingsSectionTitleDict[SettingsSection.TASKS_PROJECTS]
        this.settingsUrl              = "settings/attachments"


        this._isEnabled               = gd.company.settings.modules.attachments

    }

    // do not make it ()=>{} it will make it an instance method but we need inheritance (!)
    enable() {

        gd.company.settings.modules.attachments = true
        gd.company.settings.save()

        // !!! MEGA HACK - raznie instances... esli chto ask Vic
        this._isEnabled = true

        // @ts-ignore
        gd.modules[this.type]._isEnabled = true
    }

    disable():void {
        gd.company.settings.modules.attachments = false
        gd.company.settings.save()

        this._isEnabled = false

        // @ts-ignore
        gd.modules[this.type]._isEnabled = false
    }



    toJson() {
        debug && console.log(debug, "toJson() type=", this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }

}